module.exports = __webpack_public_path__ + "static/media/CGSE_Hero_China-Yunnan.32ed345c.jpg";